import React from 'react';
import { Box, Typography, Link } from '@mui/material';

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        width: '100%',
        textAlign: 'center',
      }}
    >
      <Typography variant="body2" color="textSecondary">
        <Link href="mailto:hej@redbar.tech" color="inherit" underline="hover">
          hej@redbar.tech
        </Link>
      </Typography>
    </Box>
  );
};

export default Footer;
